import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Career.css';
import { useSelector } from "react-redux";

const Career = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [jobsList, setJobs] = useState([]); 
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { jobs } = useSelector((state) => state.data);


  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
    setJobs(jobs)
  }, []);


  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredJobs([]);
      setShowDropdown(false);
    } else {
      const matches = jobs.filter(job =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.location.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredJobs(matches);
      setShowDropdown(matches.length > 0);
    }
  }, [searchTerm, jobs]);

  const handleSelectJob = (job) => {
    setSearchTerm(job.title);
    setShowDropdown(false);
    navigate('/job-description', { state: { job } });
  };

  const sectionStyle = {
    // backgroundImage: `url(${header_img})`, 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
  };

  if (loading) return <p>Loading job listings...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="employee-experience-section" style={sectionStyle}>
      <div className="overlay"></div>
      <div className="content-wrapper">
        <div className="text-content">
          <h1>Why Work with Akinex?</h1>
          <p>
            At Akinex, we believe in building careers, not just filling positions. Our success stems from our talented and dedicated team. We foster an inclusive and growth-oriented workplace where everyone can thrive.
          </p>
        </div>
        <div className="search-container">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Enter job title, keyword or location"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button>Search</button>
          </div>

          {/* Dropdown for search results */}
          {showDropdown && (
            <ul className="dropdown">
              {filteredJobs.map((job) => (
                <li key={job._id} onClick={() => handleSelectJob(job)}>
                  {job.title} - {job.location}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Career;